import React, { Component, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Tooltip, message } from 'antd'

import { actionCreators } from '../../store'
import styles from './index.module.css'

import sideArrowCloseImg from '../../../../statics/side_arrow_close.png'
import sideArrowOpenImg from '../../../../statics/side_arrow_open.png'

function SideBarArrow() {
    const dispatch = useDispatch()
    let is_zoom = useSelector(state => state.get('home').get('is_zoom'))
    let zoom_butn_text = useSelector(state => state.get('home').get('zoom_butn_text'))

    useEffect(() => {
        // 获取所有的 message 容器
        const messageContainer = document.querySelector('.ant-message');

        if (messageContainer) {
            // 移除所有自定义样式类
            // messageContainer.classList.remove('ant-message-custom-margin-left');
            messageContainer.classList.remove('ant-message-custom-margin-right');

            // 根据 isZoom 状态添加相应的样式类
            if (is_zoom) {
                messageContainer.classList.add('ant-message-custom-margin-right');
            // } else {
            //     messageContainer.classList.add('ant-message-custom-margin-left');
            }
        }
    }, [is_zoom])

    const handleZoomSidebar = () => {
        console.log("handleZoomSidebar");
        let result = !is_zoom
        let text = result ? "打开侧边栏" : "关闭侧边栏"

        dispatch(actionCreators.isZoomAction(result))
        dispatch(actionCreators.zoomButnTextAction(text))
    }

    return (
        <>
            <Tooltip placement="right" title={zoom_butn_text}>
                <div
                    className={styles.side_arrow_box}
                    onClick={handleZoomSidebar}
                >
                    {
                        is_zoom ? (
                            <img src={sideArrowOpenImg} className={styles.side_arrow_open} />
                        ) : (
                            <img src={sideArrowCloseImg} className={styles.side_arrow_close} />
                        )
                    }
                </div>
            </Tooltip>
        </>
    )
}

export default SideBarArrow